const shopify = window.top.Shopify
const document = window.top.document
const startTrackingEvent = new Event('startTracking')
if (shopify && shopify.loadFeatures) {
  shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1'
      }
    ],
    (error) => {
      if (error) {
        console.error('error loading features', error)
      }
    }
  )
  if (!shopify.customerPrivacy || shopify.customerPrivacy.userCanBeTracked()) {
    document.dispatchEvent(startTrackingEvent)
  }
  document.addEventListener('trackingConsentAccepted', () => {
    document.dispatchEvent(startTrackingEvent)
    document.removeEventListener('trackingConsentAccepted')
  })
} else {
  document.dispatchEvent(startTrackingEvent)
}
